// extracted by mini-css-extract-plugin
module.exports = {"cell":"TableRowCellButton-cell-1wcQj TableRowCell-cell-2fbg4 Link-link-1rgM9"};